import { Routes, Route } from "react-router-dom";
import Navbar from "./Frontend/Navbar/Navbar";
import SideBar from "./Frontend/Navbar/sideBar";
import { Box } from "@mui/material";
import { createContext, useState } from "react";
import { ToastContainer } from "react-toastify";
import NotFound from "./Frontend/Pages/NotFound";
import "./Frontend/Styles/Sidebar.css";
import GetGPS from "./Frontend/GPS/GetGPS";
import UpdateGps from "./Frontend/GPS/UpdateGps";
import PostGPS from "./Frontend/GPS/PostGPS";
import axios from "axios";
import { useEffect } from "react";
import PostGetRouter from "./Frontend/PostGps/PostGetRouter";
import PostRouter from "./Frontend/PostGps/PostRouter";
import UpdatePostRouter from "./Frontend/PostGps/UpdatePostRouter";
import Maps from "./Maps/Maps";
import GetBrands from "./Frontend/Brands/GetBrands";
import PostBrand from "./Frontend/Brands/PostBrand";
import UpdateBrand from "./Frontend/Brands/UpdateBrand";
import GetPromotions from "./Frontend/Promotions/GetPromotions";
import PostPromotion from "./Frontend/Promotions/PostPromotion";
import UpdatePromotion from "./Frontend/Promotions/UpdatePromotion";
import GetProducts from "./Frontend/Products/GetProducts";
import PostProduct from "./Frontend/Products/PostProduct";
import UpdateProduct from "./Frontend/Products/UpdateProduct";
import Dashboard from "./Frontend/Pages/Dashboard";
import GetEvents from "./Frontend/Events/GetEvents";
import PostEvent from "./Frontend/Events/PostEvent";
import UpdateEvent from "./Frontend/Events/UpdateEvent";
import GetQuotes from "./Frontend/Quotes/GetQuotes";
import QuoteStatus from "./Frontend/Quotes/QuoteStatus";
import GetUsers from "./Frontend/Users/GetUsers";

const MyContext = createContext();

const Home = () => {
  const [isToggleSidebar, setIsToggleSidebar] = useState(false);
  const [storeProducts, setStoreProducts] = useState({});
  const [storePostProducts, setStorePostProducts] = useState({});

  const values = {
    isToggleSidebar,
    setIsToggleSidebar,
  };

  useEffect(() => {
    // Fetch data from a single endpoint
    axios
      .get(`https://uktomars.co.uk/api/gps-device`)
      .then((response) => {
        // Assuming the data structure is: { data: { data: [...] } }
        const combinedData = response.data; // Adjust according to your API structure
        setStoreProducts(combinedData);
        // console.log("Fetched products:", combinedData);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch data from a single endpoint
    axios
      .get(`https://uktomars.co.uk/api/posts`)
      .then((response) => {
        // Assuming the data structure is: { data: { data: [...] } }
        const combinedData = response.data; // Adjust according to your API structure
        setStorePostProducts(combinedData);
        // console.log("Fetched products:", combinedData);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
      });
  }, []);

  return (
    <>
      <MyContext.Provider value={values}>
        <Navbar />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Box sx={{ display: "flex" }}>
          <div className={`sidebarWrapper ${isToggleSidebar ? "toggle" : ""}`}>
            <SideBar />
          </div>
          <div className={`content ${isToggleSidebar ? "toggle" : ""}`}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/GetGPS" element={<GetGPS />} />
              <Route path="/PostGPS" element={<PostGPS />} />
              <Route
                path="/GetGPS/UpdateGps/:id"
                element={<UpdateGps storeProducts={storeProducts} />}
              />
              <Route path="/PostGetRouter" element={<PostGetRouter />} />
              <Route path="/PostRouter" element={<PostRouter />} />
              <Route
                path="/PostGetRouter/UpdatePostRouter/:id"
                element={
                  <UpdatePostRouter storePostProducts={storePostProducts} />
                }
              />
              <Route path="/Maps" element={<Maps />} />
              <Route path="/admin/brands" element={<GetBrands />} />
              <Route path="/admin/brands/add" element={<PostBrand />} />
              <Route path="/admin/brands/edit/:id" element={<UpdateBrand />} />
              <Route path="/admin/promotions" element={<GetPromotions />} />
              <Route path="/admin/promotions/add" element={<PostPromotion />} />
              <Route
                path="/admin/promotions/edit/:id"
                element={<UpdatePromotion />}
              />
              <Route path="/admin/products" element={<GetProducts />} />
              <Route path="/admin/products/add" element={<PostProduct />} />
              <Route
                path="/admin/products/edit/:id"
                element={<UpdateProduct />}
              />
              <Route path="/admin/analytics" element={<Dashboard />} />
              <Route path="/admin/events" element={<GetEvents />} />
              <Route path="/admin/events/add" element={<PostEvent />} />
              <Route path="/admin/events/edit/:id" element={<UpdateEvent />} />
              <Route path="/admin/quotes" element={<GetQuotes />} />
              <Route path="/admin/quotes/:id/status" element={<QuoteStatus />} />
              <Route path="/admin/users" element={<GetUsers />} />
              <Route exact path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Box>
      </MyContext.Provider>
    </>
  );
};

export default Home;
export { MyContext };
